import React, {useMemo, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useGetPlayersList, useSearchPlayers} from "./playerHooks";
import { InputIcon } from "@iziping/ui";
import {useTranslation} from "react-i18next";
import debounce from "lodash.debounce";
import {Search} from "lucide-react";

const PlayerList: React.FC = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const {data:allPlayers, isLoading, isError} = useGetPlayersList();
    const [searchTerm, setSearchTerm] = useState('');
    const { data: searchedPlayers, isLoading: isSearching, isError: isSearchError } = useSearchPlayers(searchTerm);

    const debouncedSearch = useMemo(
        () =>
            debounce((term: string) => {
                setSearchTerm(term);
            }, 300),
        []
    );

    const playersToDisplay = searchTerm.length >= 3 ? searchedPlayers : allPlayers;

    const handlePlayerClick = (playerId: number) => {
        navigate(`/players/${playerId}`);
    };


    if (isLoading) return <div>Loading...</div>;
    if (isError) return <div>Error</div>;

    return (
        <div className={'page'}>
            <InputIcon icon={Search} placeholder={'Recherche par nom'} value={searchTerm} small={true}
                       onChange={(e) => setSearchTerm(e.target.value)}
            onKeyUp={debouncedSearch}/>

            {isLoading ? (
                <p>Chargement des joueurs...</p>
            ) : isError ? (
                <p>Une erreur est survenue lors du chargement des joueurs.</p>
            ) : (
            <table className={'table-stripped'}>
                <thead>
                    <tr>
                        <th>{t('PLAYER_FIRSTNAME')}</th>
                        <th>{t('PLAYER_LASTNAME')}</th>
                        <th>{t('PLAYER_CLUB')}</th>
                        <th>{t('PLAYER_POINTS')}</th>
                    </tr>
                </thead>
                <tbody>
                { playersToDisplay?.map((player) => (
                    <tr key={player.id} onClick={() => handlePlayerClick(player?.id || 0)}>
                        <td>{player.firstname}</td>
                        <td>{player.lastname}</td>
                        <td>{player?.club?.name || '-'}</td>
                        <td>{player.points}</td>
                    </tr>
                ))}
                </tbody>
            </table>)
            }

            <button className={"button"}><Link to="/players/new">Ajout un nouveau joueur</Link></button>


        </div>

    );
};

export default PlayerList;